import api from "../api";
import {commit} from "lodash/seq";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        expense_category: {},
        expense_categories: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    name: [],
                    is_metred: [],
                }
            }
        },
        has_errors: false,
    },
    getters: {
        loading: state => state.loading,
        expense_category: state => state.expense_category,
        dialogVisible: state => state.dialogVisible,
        expense_categories: state => state.expense_categories,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setExpenseCategories(state, data) {
            state.expense_categories = data;
        },
        setExpenseCategory(state, data) {
            state.expense_category = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getExpenseCategories({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'expense_category/list', {root: true});
                const response = await api.getExpenseCategories(filters);
                commit('setExpenseCategories', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'expense_category/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async getExpenseCategory({commit}, id) {
            try {
                commit('activateLoading', 'expense_category/list', {root: true});
                const response = await api.getExpenseCategory(id);
                commit('setExpenseCategory', response?.data);
                commit('deactivateLoading', 'expense_category/list', {root: true});
            } catch (e) {
                ElMessage.error("Something went wrong, please try again later.");
            }
        },
        async createExpenseCategory({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                const response = await api.createExpenseCategory(data);
                commit('setExpenseCategory', response?.data);
                dispatch('getExpenseCategories', {
                    paginate: true
                })
                ElMessage.success('Expense category created successfully!');
                return response?.data;
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async editExpenseCategory({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editExpenseCategory(data);
                dispatch('getExpenseCategories', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteExpenseCategory({dispatch}, data) {
            try {
                await api.deleteExpenseCategory(data);
                dispatch('getExpenseCategories', {
                    paginate: true
                })
                ElMessage.success("Expense category removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting expense category');
                }
            }
        }
    }
}
